import { create } from 'zustand';

import { StorageAPI } from '@/hooks/useStorage.ts';
import { STORAGE_KEYS } from '@/constants/local_storage_keys.ts';

type ReactionTooltipData = {
  status: 'seen' | 'new';
  shouldShow: boolean;
};

type TooltipEvent = 'like' | 'card_change';

interface TooltipStore {
  visible: boolean;
  seen: boolean;
  runTooltipFlow: (event: TooltipEvent, storage: StorageAPI) => void;
  openTooltip: () => void;
  closeTooltip: () => void;
  toggleTooltip: (v: boolean) => void;
  reset: (key: string, storage: StorageAPI) => void;
}

export const useTooltipStore = create<TooltipStore>((set, get) => ({
  visible: false,
  seen: false,
  runTooltipFlow: async (event, storage) => {
    if (get().seen) return;

    const data = (await storage.readData<ReactionTooltipData>(
      STORAGE_KEYS.REACTION_TOOLTIP
    )) ?? {
      status: 'new',
      shouldShow: false
    };

    if (data.status === 'seen') {
      set({ visible: false, seen: true });
      return;
    }

    if (event === 'like') {
      if (!data.shouldShow) {
        storage.writeData(STORAGE_KEYS.REACTION_TOOLTIP, {
          status: data.status,
          shouldShow: true
        });
      }
      return;
    }

    if (data.shouldShow) {
      set({ visible: true, seen: true });
      storage.writeData(STORAGE_KEYS.REACTION_TOOLTIP, {
        status: 'seen',
        shouldShow: false
      });
    }
  },

  openTooltip: () => set({ visible: true }),
  closeTooltip: () => set({ visible: false }),
  toggleTooltip: (v: boolean) => set({ visible: v }),

  reset: (key: string, storage) => {
    storage.removeData(key);
    set({ visible: false, seen: false });
  }
}));
